import React, { useEffect, useRef, useState } from "react";

import styles from "./IconTooltip.module.scss";

var languageFile = require("../../../../public/languages/Translation");

export const IconTooltip = (props) => {
	const tooltipRef = useRef();
	const [positionX, setPositionX] = useState(props.positionX);
	const [positionY, setPositionY] = useState(props.positionY);
	useEffect(() => {
		const edges = {
			right:
				Math.abs(props.positionX - props.canvasWidth) <
				tooltipRef.current.offsetWidth,
			bottom:
				Math.abs(props.positionY - props.canvasHeight) <
				tooltipRef.current.offsetHeight,
		};

		setPositionX(
			edges.right
				? props.positionX - tooltipRef.current.offsetWidth
				: props.positionX,
		);
		setPositionY(
			edges.bottom
				? props.positionY - tooltipRef.current.offsetHeight
				: props.positionY,
		);
	}, [tooltipRef.current, props]);

	// HIT_AREA_PAD adds an invisible buffer around the visible tooltip box —
	// mouseenter/mouseleave are tracked on this outer, padded box rather than
	// the visible box itself, so the gap the cursor has to cross to get from
	// the (tiny) hovered icon onto the tooltip is much more forgiving. The
	// inner box is shifted back by the same amount so it still renders at
	// the exact same visual position as before.
	const HIT_AREA_PAD = 24;
	return (
		<div
			className={styles.iconTooltipHitArea}
			onMouseEnter={props.onMouseEnter}
			onMouseLeave={props.onMouseLeave}
			style={{
				padding: HIT_AREA_PAD,
				transform: `translate(${positionX - HIT_AREA_PAD}px, ${positionY - HIT_AREA_PAD}px)`,
			}}>
			<div
				className={styles.iconTooltip}
				ref={tooltipRef}>
				{props.data.overlapItems && props.data.overlapItems.length > 1 ? (
					<div className={styles.iconTooltip__overlapList}>
						{props.data.overlapItems.map((overlapItem, index) => (
							<div
								className={styles.iconTooltip__overlapItem}
								key={overlapItem.reviewDocId || index}>
								{(overlapItem.storeCode || overlapItem.locationName) && (
									<p>
										{[overlapItem.storeCode, overlapItem.locationName]
											.filter(Boolean)
											.join(" / ")}
									</p>
								)}
								{overlapItem.rating && (
									<p>{`${overlapItem.rating} ${languageFile[localStorage.getItem('language')]['22191']}`}</p>
								)}
								{overlapItem.reviewer && (
									<p>{`${languageFile[localStorage.getItem('language')]['30933']}: ${overlapItem.reviewer}${overlapItem.source ? ` (${overlapItem.source})` : ""}`}</p>
								)}
							</div>
						))}
					</div>
				) : (
					<>
						{(props.data.storeCode || props.data.locationName) && (
							<p>
								{[props.data.storeCode, props.data.locationName]
									.filter(Boolean)
									.join(" / ")}
							</p>
						)}
						{props.data.rating && (
							<p>{`${props.data.rating} ${languageFile[localStorage.getItem('language')]['22191']}`}</p>
						)}
						{props.data.reviewer && (
							<p>{`${languageFile[localStorage.getItem('language')]['30933']}: ${props.data.reviewer}`}</p>
						)}
					</>
				)}
			</div>
		</div>
	);
};
